import { render, staticRenderFns } from "./MegaMenuItemComponent.vue?vue&type=template&id=19f6d6e5"
import script from "./MegaMenuItemComponent.vue?vue&type=script&lang=js"
export * from "./MegaMenuItemComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports